import React, { useEffect, useState } from "react";
import CharacterTable from "../components/characterTable";
import http from "../services/http";
const Characters = ({ setLoader, loader }) => {
  return <CharacterTable setLoader={setLoader} loader={loader} />;
};

export default Characters;
